/** Browser-side preview kind helpers (mirrors API fileTypes). */
export type PreviewKind = "pdf" | "docx" | "xlsx" | "image" | "unsupported";

export function previewKind(filename: string, mimeType = ""): PreviewKind {
  const name = filename.toLowerCase();
  const mime = mimeType.toLowerCase();
  if (mime === "application/pdf") return "pdf";
  if (mime.includes("wordprocessingml") || mime === "application/msword") return "docx";
  if (
    mime.includes("spreadsheetml") ||
    mime === "text/csv" ||
    mime === "application/vnd.ms-excel"
  )
    return "xlsx";
  if (mime.startsWith("image/")) return "image";
  if (name.endsWith(".pdf")) return "pdf";
  if (name.endsWith(".docx") || name.endsWith(".doc")) return "docx";
  if (name.endsWith(".xlsx") || name.endsWith(".xls") || name.endsWith(".csv")) return "xlsx";
  if (/\.(png|jpe?g|webp|gif)$/i.test(name)) return "image";
  return "unsupported";
}

export function isOfficeFile(filename: string, mimeType = ""): boolean {
  const name = filename.toLowerCase();
  const mime = mimeType.toLowerCase();
  return (
    /\.(docx?|xlsx?|xls|pptx?|ppt)$/i.test(name) ||
    mime.includes("wordprocessingml") ||
    mime === "application/msword" ||
    mime.includes("spreadsheetml") ||
    mime === "application/vnd.ms-excel" ||
    mime.includes("presentationml") ||
    mime === "application/vnd.ms-powerpoint"
  );
}
